/**
 * @generated SignedSource<<996dce97ecbd2d1f2ad653af5fc131c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AttendeeStatus = "going" | "not_going" | "%future added value";
export type EventType = "IN_PERSON" | "LIVE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type eventCard$data = {
  readonly address: string | null | undefined;
  readonly attendee: {
    readonly status: AttendeeStatus;
  } | null | undefined;
  readonly attendeeCount: number;
  readonly coverPhoto: {
    readonly signedUrl: string;
  } | null | undefined;
  readonly endDate: any;
  readonly eventUrl: string | null | undefined;
  readonly host: {
    readonly avatarFallback: string;
    readonly displayName: string | null | undefined;
    readonly photo: {
      readonly signedUrl: string;
    } | null | undefined;
  };
  readonly id: string;
  readonly slug: string;
  readonly startDate: any;
  readonly timezone: string;
  readonly title: string;
  readonly type: EventType;
  readonly " $fragmentType": "eventCard";
};
export type eventCard$key = {
  readonly " $data"?: eventCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventCard">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signedUrl",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "eventCard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attendeeCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageFile",
      "kind": "LinkedField",
      "name": "coverPhoto",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attendee",
      "kind": "LinkedField",
      "name": "attendee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "host",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageFile",
          "kind": "LinkedField",
          "name": "photo",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarFallback",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "e8bf6083ed828a5e798a6f341619c092";

export default node;
